import React, {Component} from 'react';
import PrivacyLink from './Privacy';
import {BasicCard, ListCard, SimpleText, SimpleGrid} from './Balloon/AnswerBalloon'
import CarouselBalloon from './Balloon/CarouselBalloon'
import QuickReplies from './QuickReplies'
import QuickRepliesSelect from './QuickRepliesSelect'
import { getTalkTime } from '../utils/utils'

class BotMessages extends Component {

    componentDidMount() {
        
    }

    componentDidUpdate(prevProps, prevState) {
        // console.log(this.props.sendData)
    }
    
    shouldComponentUpdate(nextProps, nextState){
        return (nextProps === this.props);
    }

    render() {
        const BotMessages = this.props.data.map (
            (message, i) => (
                message.carousel 
                    ? <CarouselBalloon key={i} data={ message.carousel } fromApp={this.props.fromApp}/> : 
                message.simpleText 
                    ? <SimpleText key={i} data={ message.simpleText } isGreeting={this.props.isGreeting} fromCarousel={false} fromApp={this.props.fromApp}/> : 
                message.basicCard  
                    ? <BasicCard key={i} data={ message.basicCard } fromCarousel={false} fromApp={this.props.fromApp}/> : 
                message.listCard 
                    ? <ListCard key={i} data={ message.listCard } fromApp={this.props.fromApp}/> :
				message.simpleGrid
                    && <SimpleGrid key={i} data={ message.simpleGrid } isGreeting={this.props.isGreeting} fromApp={this.props.fromApp}/>
            )
        )
        //<div className="img_wrap"></div><p>&nbsp;{ this.props.isGreeting && <PrivacyLink/> }</p></div>
        const timeStyle = {
            fontSize : "1.1rem",
            color : "#999",
            paddingLeft : "10px",
            //width : "80px",
        }
        //<div style={timeStyle}>{getTalkTime()}</div>
        return (
            <React.Fragment>
                <span className="bot_box">
                    <span className="ico_comm ico_chatbot"></span>
                </span>
                { BotMessages }
                { this.props.quickBtns !== undefined  
                    && this.props.quickBtns.length < 4 && <QuickReplies data={this.props.quickBtns} fromApp={this.props.fromApp}/> 
                }
                { this.props.quickBtns !== undefined  
                    && this.props.quickBtns.length >= 4 && <QuickRepliesSelect data={this.props.quickBtns} fromApp={this.props.fromApp} uiTexts={this.props.uiTexts}/> 
                }
                <span className="bubble_time">{getTalkTime()}</span>
            </React.Fragment>
        );
    }
};

export default BotMessages;